import { render } from "./ExtractionHoldings.vue?vue&type=template&id=26e69637"
import script from "./ExtractionHoldings.vue?vue&type=script&lang=js"
export * from "./ExtractionHoldings.vue?vue&type=script&lang=js"

import "./ExtractionHoldings.vue?vue&type=style&index=0&id=26e69637&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__